import { tickerItems } from "@/mocks/home";

export default function FlashTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <section className="border-b border-background-200/70 bg-background-100/70">
      <div className="mx-auto flex max-w-[1280px] items-stretch px-4 md:px-6">
        <div className="flex shrink-0 items-center gap-2 py-3 pr-4 md:pr-6">
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-xs"></i>
          </span>
          <span className="font-heading text-sm font-bold whitespace-nowrap text-foreground-950">
            情报速报
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden border-l border-background-300/70">
          <div className="flex w-max animate-ticker items-center">
            {loop.map((item, i) => (
              <div key={`${item.text}-${i}`} className="flex items-center gap-2 px-6">
                <span className="text-xs font-medium text-primary-600">{item.time}</span>
                <span className="text-sm whitespace-nowrap text-foreground-700">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}